document.addEventListener('turbolinks:load', () => {
    const bt_beacon_group_beacon_type = document.getElementById('bt_beacon_group_beacon_type')
    const btAlarmBeaconOptions = document.getElementById('btAlarmBeaconOptions')
    const btBeaconWarning = document.getElementById('btBeaconWarning')
    const isActive = document.getElementById('isActive')
    const isActiveButton = document.getElementById('isActiveButton')
    const isActiveAdditionalInfoText = document.getElementById('isActiveAdditionalInfoText')

    // isActive only exists if the beacon_group.is_active in the beginning
    if (isActive !== null && isActiveButton !== null && isActiveAdditionalInfoText !== null){
        isActiveAdditionalInfoText.classList.add('hidden')
        // add click listener which toggles the info text that beacon group was deactivated
        isActiveButton.addEventListener('click', function (event) {
            if (isActiveButton.ariaPressed) {
                isActiveAdditionalInfoText.classList.remove('hidden')
            } else {
                isActiveAdditionalInfoText.classList.add('hidden')
            }
        })
    }

    // depending on the beacon type, the alarm options are shown or hidden
    if(bt_beacon_group_beacon_type !== null && btAlarmBeaconOptions !== null){
        bt_beacon_group_beacon_type.addEventListener('change', function (event) {
            if(bt_beacon_group_beacon_type.value === "alarm") {
                btAlarmBeaconOptions.classList.remove('hidden')
            } else if (bt_beacon_group_beacon_type.value === "station"){
                btAlarmBeaconOptions.classList.add('hidden')
            }
            // show warning that the beacon type was changed
            if (btBeaconWarning !== null) {
                let originalType = bt_beacon_group_beacon_type.dataset.originalType
                if (originalType === bt_beacon_group_beacon_type.value) {
                    btBeaconWarning.classList.add('hidden')
                } else {
                    btBeaconWarning.classList.remove('hidden')
                }
            }
        })
    }
})